module.exports = __webpack_public_path__ + "static/img/icon_wx.673f5ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon_wx.png
// module id = BNyJ
// module chunks = 71